import React from 'react';
import { string, shape, bool } from 'prop-types';

import { makeParagraph } from 'utils';
import Icon from 'components/icon';

const TradeShowCard = ({
    appointmentButton,
    date,
    description,
    image,
    info,
    link,
    location,
    title
}) => (
    <article className="c-trade-show-card">
        <div className="c-trade-show-card__image">
            {!!image && !!image.url && (
                <img
                    className="b-lazy"
                    data-src={image.url}
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    alt={image.alt}
                />
            )}
        </div>
        <div className="c-trade-show-card__body">
            <div className="c-trade-show-card__header">
                {title && (
                    <h2 className="c-trade-show-card__title h3">{title}</h2>
                )}
                {date && <span>{date}</span>}
            </div>
            <div className="grid">
                <div className="col-sm-6 c-trade-show-card__location-col">
                    {location && (
                        <span className="c-trade-show-card__location">
                            {location}
                        </span>
                    )}
                    {info && (
                        <span className="c-trade-show-card__info">{info}</span>
                    )}
                </div>
                <div className="col-sm-6 c-trade-show-card__description-col">
                    {description && (
                        <div
                            className="c-trade-show-card__description"
                            dangerouslySetInnerHTML={{
                                __html: makeParagraph(description)
                            }}
                        />
                    )}
                </div>
            </div>
            <div className="c-trade-show-card__links">
                {!!link && !!link.url && (
                    <a
                        className={`c-trade-show-card__info-link link link--icon-suffix ${
                            link.disabled ? 'link--disabled' : ''
                        }`}
                        href={link.url}
                        target={link.target}
                    >
                        {link.title}
                        <Icon glyph="off-site" />
                    </a>
                )}
                {!!appointmentButton && !!appointmentButton.email && (
                    <a
                        className={`button button--primary c-trade-show-card__appointment-button ${
                            appointmentButton.disabled ? 'button--disabled' : ''
                        }`}
                        href={`mailto: ${appointmentButton.email}`}
                    >
                        {appointmentButton.title}
                        <Icon glyph="arrow-right" />
                    </a>
                )}
            </div>
        </div>
    </article>
);

TradeShowCard.propTypes = {
    appointmentButton: shape({
        title: string,
        disabled: bool,
        email: string
    }),
    date: string.isRequired,
    description: string,
    id: string,
    image: shape({
        url: string,
        alt: string
    }),
    info: string,
    link: shape({
        title: string,
        url: string,
        target: string,
        disabled: bool
    }),
    location: string.isRequired,
    title: string.isRequired
};

export default TradeShowCard;
